import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';

import { styles } from './styles.index';

export interface PlanActionTableHeadProps {}

const PlanActionTableHead: FC<PlanActionTableHeadProps> = () => {
  const { t } = useTranslation(['planAction', 'common']);

  return (
    <TableRow>
      <TableCell sx={styles.tableHeadCell}>
        {t('planAction:ActionPlan.ActionPlanName')}
      </TableCell>

      <TableCell sx={styles.tableHeadCell}>
        {t('planAction:ActionPlan.ActionPlanOwner')}
      </TableCell>

      <TableCell sx={styles.tableHeadCell}>
        {t('planAction:ActionPlan.ActionPlanStatus')}
      </TableCell>

      <TableCell sx={styles.tableHeadCell} align="right">
        {t('common:copy')}
      </TableCell>

      <TableCell sx={styles.tableHeadCell} align="right">
        {t('common:Download')}
      </TableCell>
    </TableRow>
  );
};

export default PlanActionTableHead;
